import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryStockTransferApprovalLog } from "./thunk";

interface initialStateType {
  StockTransferApprovalLogList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  StockTransferApprovalLogList: [],  
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryItemRequestStockTransferRequestApprovalLogSlice = createSlice({
  name: "InventoryStockTransfer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryStockTransferApprovalLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryStockTransferApprovalLog.fulfilled, (state, action) => {
        state.loading = false;
        state.StockTransferApprovalLogList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryStockTransferApprovalLog.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch fetchInventoryStockTransferApprovalLog";
      });
  },
});

export default InventoryItemRequestStockTransferRequestApprovalLogSlice.reducer;
